import { authenticatedClient } from './util'
import { HTTP_SUCCESS } from '../helpers/utils/http-status'
import { Membership } from '../types'

const fetchWallet = async (membershipId: string) => {
    return authenticatedClient()
        .post(
            `/api/vouchermatic/get-wallet`,
            {
                customerReference: membershipId,
            },
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not fetch wallet`)
            }
            return res
        }).then(res => res.data).catch(() => {
            return ``
        })
}

const createCustomer = async (membership?: Membership) => {
    return authenticatedClient()
        .post(
            `/api/vouchermatic/create-customer`,
            {
                membership,
            },
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not retrieve user data`)
            }
            return res
        }).then(res => res.data)
}

export {
    fetchWallet,
    createCustomer,
}